var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("SubcategoriesController", [
    "$scope", "$rootScope", "$window", "categoryElasticService", "catalogService", "configs", "elasticService", 'loaderService', 
    "urlService",
    function ($scope, $rootScope, $window, categoryElasticService, catalogService, configs, elasticService, loaderService, urlService) {
        //#region  initialize functions
        $scope.initialize = function () {

            var filteredProductDefinitions = function (productDefinitions, def) {
                return Object.values(productDefinitions).filter(
                    function (definition) {
                        return definition.replace(/\s+/g, '').toLowerCase().includes(def);
                    }
                );
            };

            $rootScope.showLoader = true;
            if (angular.isDefined($window.category)) {
                $scope.category = $window.category.replace(/-/g, ' ');
            }
            if (angular.isDefined($window.prdDefinition)) {
                var filteredPrdType = filteredProductDefinitions(catalogService.productDefinition, $window.prdDefinition);
                filteredPrdType = filteredPrdType && filteredPrdType.length > 0 ? filteredPrdType[0] : catalogService.capitalizeFirstLetter($window.prdDefinition);
                $scope.prdDef = filteredPrdType;
            }
            if (angular.isDefined($window.freeProducts)) {
                $scope.freeProducts = ($window.freeProducts.toLowerCase() === 'true');
            }

            if($scope.prdDef.toLowerCase() =='stockdesign'){
                    $scope.displayPrdType = $scope.freeProducts ? $rootScope.localeVariables.freeDesigns:$rootScope.localeVariables.designs;
                }
            else if($scope.prdDef.toLowerCase() =='font'){
                    $scope.displayPrdType = $rootScope.localeVariables.fonts;;
                }
            else if($scope.prdDef.toLowerCase() === 'designpack'){
                    $scope.displayPrdType = $rootScope.localeVariables.designPacks || 'Design Packs';
                }
            else if($scope.prdDef.toLowerCase() === 'fontpack'){
                    $scope.displayPrdType = $rootScope.localeVariables.fontPacks || 'Font Packs';
                }
            else{
                    $scope.displayPrdType = $scope.prdDef;
                }
            $rootScope.logoutUrl = "account/logout" + "?returnurl=" +  $window.location.pathname;
            getEmbroidersPicks();
        }
        //#endregion

        //#region Embroiderers picks
        function getEmbroidersPicks() {
            loaderService.show();
            elasticService.getElasticData(
                categoryElasticService.buildCategorySamplesRequest($scope.prdDef, $scope.category,$scope.freeProducts),
                configs.elasticBaseUrl
            ).then(
                function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        $scope.embroidersPicks = response.data.hits.hits;
                        getSubCategoriesPageUrl($scope.category);
                        
                        // Generate structured data for subcategories
                        $scope.generateSubcategoriesStructuredData();
                        
                        loaderService.hide();
                    }
                },
                function (response) {
                    loaderService.hide();
                }
            );
        }
        //#endregion

        function getSubCategoriesPageUrl (category){
                $scope.pageUrl = urlService.getCategoryListingUrl(
                    category,
                    $scope.prdDef,
                    $scope.freeProducts
                );
        }

        // Generate structured data for visual search results (product images)
        $scope.generateSubcategoriesStructuredData = function() {
            // Check if we have embroidersPicks data
            if (!$scope.embroidersPicks || $scope.embroidersPicks.length === 0) {
                return;
            }

            // Get page metadata
            var pageTitle = window.metaTitle || 'Subcategories';
            var canonicalUrl = window.canonicalUrl || window.location.href;

            // Generate item list elements (limit to 8 for performance)
            var itemListElements = $scope.embroidersPicks.slice(0, 8).map(function(item, index) {
                item.url = "https://www.embroiderydesigns.com/" + urlService.getProductUrl({
                    definitionName: item._source.definitionName,
                    catalogId: item._source.catalog,
                    name: item._source.name,
                    sku: item._source.itemId,
                });
                var productData = {
                    "@type": "ListItem",
                    "position": index + 1,
                    "item": {
                        "@type": "Product",
                        "@id": item._source.itemId + "#product",
                        "name": item._source.name,
                        "description": item._source.description || item._source.name,
                        "image": [{
                            "@type": "ImageObject",
                            "name": item._source.name,
                            "contentUrl": item.imgUrl,
                            "thumbnail": item.imgUrl,
                            "description": item._source.name + " - " + item._source.catalog,
                            "url": item.url
                        }],
                        "brand": {
                            "@type": "Brand",
                            "name": item._source.catalog
                        },
                        "sku": item._source.itemId,
                        "category": item._source.definitionName,
                        "offers": {
                            "@type": "Offer",
                            "url": item.url,
                            "priceCurrency": "USD",
                            "price": item._source.salePrice > 0 ? item._source.salePrice : item._source.listPrice,
                            "availability": "https://schema.org/InStock",
                            "itemCondition": "https://schema.org/NewCondition",
                            "seller": {
                                "@type": "Organization",
                                "name": "EmbroideryDesigns.com"
                            }
                        }
                    }
                };

                // Add rating if available
                if (item._source.rating && item._source.rating > 0) {
                    productData.item.aggregateRating = {
                        "@type": "AggregateRating",
                        "bestRating": "5",
                        "worstRating": "1",
                        "ratingValue": item._source.rating.toString(),
                        "reviewCount": (item._source.ratingsCount || 1).toString()
                    };
                }

                return productData;
            });

            // Create minimal structured data for visual search results
            var structuredData = {
                "@context": "https://schema.org/",
                "@type": "CollectionPage",
                "name": pageTitle,
                "url": canonicalUrl,
                "mainEntity": {
                    "@type": "ItemList",
                    "name": pageTitle,
                    "numberOfItems": $scope.embroidersPicks.length.toString(),
                    "itemListElement": itemListElements
                }
            };

            // Remove any existing structured data script for subcategories
            var existingScript = document.querySelector('script[data-subcategories-structured-data]');
            if (existingScript) {
                existingScript.remove();
            }

            // Create and inject the new structured data script
            var script = document.createElement('script');
            script.type = 'application/ld+json';
            script.setAttribute('data-subcategories-structured-data', 'true');
            script.textContent = JSON.stringify(structuredData);
            document.head.appendChild(script);
        };
    }
]);
